export default __webpack_public_path__ + "static/media/Team_Workouts.e11623bc.jpeg";